/**
 * ConnectorIcon — one inline SVG per connector type. Stroke uses
 * `currentColor` so the caller drives the color via a text class.
 */

import type { ConnectorType } from '@/api/types';

export function ConnectorIcon({
  type,
  className,
}: {
  type: ConnectorType;
  className?: string;
}) {
  const props = {
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.8,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
    className,
    'aria-hidden': true,
  };

  switch (type) {
    case 'rest_api':
      return (
        <svg {...props}>
          <path d="M4 7h6M4 12h10M4 17h6" />
          <path d="M15 9l4 3-4 3" />
        </svg>
      );
    case 'webhook':
      return (
        <svg {...props}>
          <circle cx="8" cy="9" r="3" />
          <circle cx="17" cy="15" r="3" />
          <circle cx="7" cy="18" r="2" />
          <path d="M10.5 10.5L15 13M8 12v4" />
        </svg>
      );
    case 'email':
      return (
        <svg {...props}>
          <rect x="3" y="5" width="18" height="14" rx="2" />
          <path d="M3 7l9 6 9-6" />
        </svg>
      );
    case 'file_storage':
      return (
        <svg {...props}>
          <ellipse cx="12" cy="6" rx="8" ry="3" />
          <path d="M4 6v6c0 1.7 3.6 3 8 3s8-1.3 8-3V6" />
          <path d="M4 12v6c0 1.7 3.6 3 8 3s8-1.3 8-3v-6" />
        </svg>
      );
    case 'database':
      return (
        <svg {...props}>
          <ellipse cx="12" cy="5" rx="8" ry="2.5" />
          <path d="M4 5v6c0 1.4 3.6 2.5 8 2.5s8-1.1 8-2.5V5" />
          <path d="M4 11v6c0 1.4 3.6 2.5 8 2.5s8-1.1 8-2.5v-6" />
          <path d="M8 8.5v.1M8 14.5v.1" />
        </svg>
      );
    case 'scheduler':
      return (
        <svg {...props}>
          <circle cx="12" cy="12" r="9" />
          <path d="M12 7v5l3 2" />
        </svg>
      );
    default:
      return (
        <svg {...props}>
          <rect x="4" y="4" width="16" height="16" rx="2" />
        </svg>
      );
  }
}
